import React, { useState } from "react";
import { X } from "lucide-react";
import { useI18n } from "../lib/i18n";
import { TEAM } from "../data/content";

export default function Team() {
  const { t, lang } = useI18n();
  const isAr = lang === "ar";
  const [openMember, setOpenMember] = useState(null);

  return (
    <div data-testid="team-page" className="max-w-7xl mx-auto px-6 lg:px-10 py-24">
      <div className="grid lg:grid-cols-12 gap-12 mb-16">
        <div className="lg:col-span-5">
          <p className="eyebrow">{t.nav.team}</p>
          <h1 className="font-display text-5xl lg:text-6xl mt-4 leading-[1.0] tracking-tight">
            {isAr ? "فريقنا القانوني." : "Our team."}
          </h1>
        </div>
        <div className="lg:col-span-7 lg:pt-3">
          <p className="text-lg text-slate-600 leading-relaxed">
            {isAr
              ? "محامون يجمعون بين الانضباط الأكاديمي والممارسة العميقة أمام محاكم الكويت ومؤسسات التحكيم الإقليمية."
              : "Lawyers who pair academic discipline with deep, practical experience before the Kuwaiti courts and the region's arbitral institutions."}
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16">
        {TEAM.map((m, i) => (
          <button
            type="button"
            key={`team-${m.id || m.name_en}-${i}`}
            data-testid={`team-card-${i}`}
            onClick={() => setOpenMember(m)}
            className="group text-start"
          >
            <div className="aspect-[4/5] overflow-hidden bg-slate-100">
              <img
                src={m.photo}
                alt={m.name_en}
                className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700"
              />
            </div>
            <h3 className="font-display text-2xl mt-5 leading-tight">
              {isAr ? m.name_ar : m.name_en}
            </h3>
            <p className="text-sm text-slate-500 mt-1">
              {isAr ? m.role_ar : m.role_en}
            </p>
            <p className="mt-3 text-sm text-slate-700">
              {isAr ? m.focus_ar : m.focus_en}
            </p>
            <span className="mt-4 inline-block text-xs uppercase tracking-[0.18em] border-b border-slate-900 pb-1">
              {isAr ? "السيرة الكاملة" : "Read full bio"}
            </span>
          </button>
        ))}
      </div>

      {/* Bio modal */}
      {openMember ? (
        <div
          role="dialog"
          aria-modal="true"
          data-testid="team-bio-modal"
          className="fixed inset-0 z-50 bg-slate-900/60 backdrop-blur-sm flex items-center justify-center p-4"
          onClick={() => setOpenMember(null)}
        >
          <div
            className="bg-white max-w-3xl w-full max-h-[85vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="grid sm:grid-cols-12">
              <div className="sm:col-span-5 bg-slate-100">
                <img
                  src={openMember.photo}
                  alt={openMember.name_en}
                  className="w-full h-64 sm:h-full object-cover"
                />
              </div>
              <div className="sm:col-span-7 p-8 lg:p-10 relative">
                <button
                  type="button"
                  onClick={() => setOpenMember(null)}
                  data-testid="team-bio-close"
                  className="absolute top-4 end-4 w-9 h-9 grid place-items-center border border-slate-200 hover:border-slate-900"
                  aria-label="Close"
                >
                  <X className="w-4 h-4" />
                </button>
                <p className="eyebrow">{isAr ? openMember.role_ar : openMember.role_en}</p>
                <h2 className="font-display text-3xl lg:text-4xl mt-3 leading-tight">
                  {isAr ? openMember.name_ar : openMember.name_en}
                </h2>
                <p className="mt-3 text-sm text-slate-700">
                  {isAr ? openMember.focus_ar : openMember.focus_en}
                </p>
                <div className="mt-6 hairline pt-6 text-base text-slate-700 leading-[1.85] whitespace-pre-line">
                  {isAr ? openMember.bio_ar : openMember.bio_en}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}
